var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils } from './_default-imports';
//namespace Pacem.Components {
let PacemBroadcastChannelProxyElement = class PacemBroadcastChannelProxyElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this.autosend = true;
        this._messageHandler = (evt) => {
            this.result = evt.data;
            this.dispatchEvent(new CustomEvent('receive', { detail: evt.data, bubbles: false, cancelable: false }));
        };
        this._errorHandler = (evt) => {
            this.dispatchEvent(new CustomEvent('error', { detail: evt.data, bubbles: false, cancelable: false }));
        };
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._initializeChannel();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'src':
                    this._disposeChannel();
                    this._initializeChannel(val);
                    break;
                case 'autosend':
                case 'disabled':
                case 'message':
                    if (this.autosend) {
                        this.send(this.message);
                    }
                    break;
            }
        }
    }
    disconnectedCallback() {
        this._disposeChannel();
        super.disconnectedCallback();
    }
    send(message = this.message) {
        if (this.disabled) {
            return;
        }
        const channel = this.#channel;
        if (!Utils.isNull(channel)) {
            channel.postMessage(message);
        }
    }
    #channel;
    _initializeChannel(name = this.channelName) {
        if (!Utils.isNullOrEmpty(name)) {
            const channel = this.#channel = new BroadcastChannel(name);
            channel.addEventListener('message', this._messageHandler, false);
            channel.addEventListener('messageerror', this._errorHandler, false);
            if (this.autosend && !Utils.isNull(this.message)) {
                this.send();
            }
        }
    }
    _disposeChannel(channel = this.#channel) {
        if (!Utils.isNull(channel)) {
            channel.removeEventListener('messageerror', this._errorHandler, false);
            channel.removeEventListener('message', this._messageHandler, false);
            channel.close();
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemBroadcastChannelProxyElement.prototype, "message", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemBroadcastChannelProxyElement.prototype, "result", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemBroadcastChannelProxyElement.prototype, "channelName", void 0);
__decorate([
    Watch({ emit: false, reflectBack: true, converter: PropertyConverters.Boolean })
], PacemBroadcastChannelProxyElement.prototype, "autosend", void 0);
PacemBroadcastChannelProxyElement = __decorate([
    CustomElement({ tagName: P + '-broadcastchannel-proxy' })
], PacemBroadcastChannelProxyElement);
export { PacemBroadcastChannelProxyElement };
//}
